import React from 'react';
import InputSearch from '../../../../../src/web/containers/SMInputSearch';
import SearchNearby from '../../../../../src/web/containers/SMSearchNearby';
import NearbyAndInput from '../../../components/stateful/SMNearbyAndInput';

const displayOpts = [
  {
    label: 'Include only Search by Zip/Postal/City',
    value: 'onlyInput',
    component: <InputSearch />,
  },
  {
    label: 'Include only Search Nearby Locations',
    value: 'onlyNearby',
    component: <SearchNearby />,
  },
  {
    label: 'Include both Search by Zip/Postal/City and Search Nearby Locations',
    value: 'both',
    default: true,
    component: <NearbyAndInput />,
  },
];

export default displayOpts;
